export enum IriEnums {
    STORY = "/api/stories",
    STORY_PAGE = "/api/story-pages",
    STORY_ITEM = "/api/story-items",
}
